export default __webpack_public_path__ + "static/media/searchicon.d97a8f6f.png";